var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hero'),_c('javascript-components'),_c('icons'),_c('examples'),_c('download-section'),_c('carousel'),_c('typography'),_vm._m(0),_c('images')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"mt-lg mb-5",staticStyle:{"text-align":"center"}},[_c('span',[_vm._v("Ý kiến khách hàng")])])
}]

export { render, staticRenderFns }